import requester from "../requester";
import { GET_AMENITIES, GET_AMENITIES_OFFICE } from "../../constants";

const Amenities = {
  getAmenities: () => requester.get(GET_AMENITIES),
  getAmenitiesOffice: () => requester.get(GET_AMENITIES_OFFICE),
};

export default Amenities;
